// src/hooks/useFurigana.js

import { useState, useEffect, useCallback } from 'react';

const FURIGANA_STORAGE_KEY = 'kikikata_furigana_visibility';
const FURIGANA_CHANGE_EVENT = 'kikikata_furigana_change';

// Function to get the initial value from localStorage
const getStoredValue = () => {
  try {
    const item = window.localStorage.getItem(FURIGANA_STORAGE_KEY);
    // Default to true (visible) if no setting is stored yet
    return item ? JSON.parse(item) : true;
  } catch (error) {
    console.error("Error reading furigana visibility from localStorage", error);
    return true;
  }
};

export const useFurigana = () => {
  const [showFurigana, setShowFurigana] = useState(getStoredValue);

  // This effect listens for our custom event and updates the state
  useEffect(() => {
    const handleStorageChange = () => {
      setShowFurigana(getStoredValue());
    };

    window.addEventListener(FURIGANA_CHANGE_EVENT, handleStorageChange);
    return () => {
      window.removeEventListener(FURIGANA_CHANGE_EVENT, handleStorageChange);
    };
  }, []);

  // This function updates localStorage and dispatches the event
  const setFuriganaVisibility = useCallback((value) => {
    const newValue = typeof value === 'function' ? value(getStoredValue()) : value;
    try {
      window.localStorage.setItem(FURIGANA_STORAGE_KEY, JSON.stringify(newValue));
      // Dispatch a custom event to notify other components using this hook on the same page
      window.dispatchEvent(new Event(FURIGANA_CHANGE_EVENT));
    } catch (error) {
      console.error("Error setting furigana visibility in localStorage", error);
    }
  }, []);

  return [showFurigana, setFuriganaVisibility];
};